import styled from "styled-components";
import Button from "../../../bootstrap/Button";
import NavItem from "../../../bootstrap/NavItem";
import Ul from "../../../bootstrap/Ul";

export const PaymentAndButton = styled.div`
  display: grid;
  grid-template-columns: 70% 30%;
  align-items: center;
  margin-top: 20px;
  justify-content: flex-end;
  @media (max-width: 768px) {
    grid-template-columns: 100%;
  }
`;
export const PaymentUl = styled(Ul)`
  margin: 0;
  margin-top: 10px;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  list-style: none;
  font-size: 16px;
`;


export const ButtonWrapper = styled.div`
  text-align: right;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  @media (max-width: 576px) {
    margin-top: 20px;
    justify-content: flex-start;
  }
`;
export const CancelButton = styled(Button)`
  margin-right: 10px;
  text-transform: capitalize;
`;
export const PaymentButton = styled(Button)`
  text-transform: capitalize;
  ${(props) => ` 
background: ${props.btnbgcolor};
transition: 0.4s;
color: ${props.btntextcolor};
&&:hover {
  background: ${props.btnbghvcolor};
}
`}
`;
export const Label = styled.label`
  cursor: pointer;
  width: 100%;
  display: block;
  padding: 10px 15px;
`;

export const SinglePayment = styled(NavItem)`
  margin-right: 15px;
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 8px;
  transition: all 0.3s ease;
  background: ${props => props.active ? '#f0f7ff' : '#fff'};
  border-color: ${props => props.active ? '#007bff' : '#ddd'};
  
  &:hover {
    border-color: #007bff;
    background: #f8fbff;
  }
`;

export const PaymentInput = styled.input`
  display: none;
`;

export const PaymentMethod = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 30px;
  gap: 15px;
`;
